import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'src/store';

export const routerSliceSelector = (state: RootState) => state.router;

export const previousLocationSelector = createSelector(routerSliceSelector, (state) => state.previousLocation);
